import script from "./DebugErrorOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugErrorOverlay.vue?vue&type=script&setup=true&lang=js"

import "./DebugErrorOverlay.vue?vue&type=style&index=0&id=7c3d7b32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3d7b32"]])

export default __exports__